import {useNewProduct} from "../../../store/contexts/NewProductContext";
import {TYPES} from "../../../store/reducers/NewProductReducer";
import {useSelector} from "react-redux";
import {userCan, userCanAny} from "../../../Components/Helpers/Utils";

const MarketCard = () => {
    const user = useSelector(state => state.user);
    const { product,  dispatch, errors, data } = useNewProduct();

    return (
        <div className="card card-flush py-4">
            <div className="card-header">
                <div className="card-title">
                    <h2>Market</h2>
                </div>
            </div>

            <div className="card-body pt-0">
                <div className="fv-row mb-2">
                    <div className="mb-10 fv-row">
                        <label className="form-label">Market Name</label>
                        <input type="text" name="product_name" className="form-control mb-2"
                               placeholder="Market name" value={ product.market_name ?? ""}
                               onChange={event => dispatch({
                                   type: TYPES.SET_PRODUCT,
                                   payload: {...product, market_name: event.target.value}
                               })}
                        />
                        {
                            errors.hasOwnProperty("market_name") && (
                                <div className="fs-7 mb-7 text-danger">{errors.market_name}</div>
                            )
                        }
                        <div className="text-muted fs-7">A market name is not required
                        </div>
                    </div>
                </div>
            </div>

          {
            (user?.roles?.includes('Super Admin') ||
              userCanAny(user?.permissions, ['Product Add', 'Product Edit'])) && (
              <div className="card-body pt-0">
                <label className="required form-label">Seller</label>
                <select className="form-select mb-2" data-control="select2" data-hide-search="true"
                        data-placeholder="Select an option" id="kt_ecommerce_add_product_status_select"
                        onChange={event => dispatch({
                          type: TYPES.SET_PRODUCT,
                          payload: {...product, shop_id: parseInt(event.target.value)}
                        })}
                        value={product.shop_id || ''}
                >
                  <option>Select Seller</option>
                  {
                    data?.shops?.map((shop, index) => (
                      <option key={index} value={shop.id}>{shop.name}</option>
                    ))
                  }
                </select>
                {
                  errors.hasOwnProperty("shop_id") && (
                    <div className="fs-7 mb-7 text-danger">{errors.shop_id}</div>
                  )
                }
                <div className="text-muted fs-7 mb-7">Select product seller</div>
              </div>
            )}
        </div>
    )
}

export default MarketCard;